/* ============================================================
   AYDO® — shared behaviour
   Every selector is `ay-` / `data-ay-*` namespaced so nothing here
   can collide with Fabric's own scripts.
   ============================================================ */
(function () {
  "use strict";

  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- generic dialog (size guide, and anything else) ----
     Opens on a [data-ay-dialog-open="ID"] trigger, traps focus,
     closes on Escape or scrim, and hands focus back to the opener. */
  function initDialog(dlg) {
    var panel = dlg.querySelector(".ay-dialog__panel");
    var opener = null;

    function open(from) {
      opener = from || document.activeElement;
      dlg.hidden = false;
      /* reflow, then set synchronously: requestAnimationFrame is throttled in
         background tabs, which would leave the panel stuck at opacity 0 */
      void dlg.offsetWidth;
      dlg.dataset.open = "true";
      document.body.style.overflow = "hidden";
      var f = panel.querySelector("button, [href], input");
      if (f) f.focus({ preventScroll: true });
    }
    function close() {
      dlg.dataset.open = "false";
      document.body.style.overflow = "";
      setTimeout(function () { dlg.hidden = true; }, RM ? 0 : 260);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }
    dlg._ayOpen = open;

    all("[data-ay-dialog-close]", dlg).forEach(function (b) { on(b, "click", close); });
    on(dlg.querySelector(".ay-dialog__scrim"), "click", close);
    on(document, "keydown", function (e) {
      if (dlg.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(); return; }
      if (e.key !== "Tab") return;
      var f = all("button, [href], input, select, textarea", panel).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  all(".ay-dialog").forEach(initDialog);
  on(document, "click", function (e) {
    var t = e.target.closest ? e.target.closest("[data-ay-dialog-open]") : null;
    if (!t) return;
    e.preventDefault();
    var dlg = document.getElementById(t.getAttribute("data-ay-dialog-open"));
    if (dlg && dlg._ayOpen) dlg._ayOpen(t);
  });

  /* ---------- accordions ------------------------------------ */
  all("[data-ay-acc]").forEach(function (btn) {
    on(btn, "click", function () {
      var open = btn.getAttribute("aria-expanded") === "true";
      btn.setAttribute("aria-expanded", String(!open));
      var p = document.getElementById(btn.getAttribute("aria-controls"));
      if (p) p.hidden = open;
    });
  });

  /* ---------- mobile sheet ---------------------------------- */
  (function () {
    var burger = document.querySelector("[data-ay-burger]");
    var sheet = document.querySelector("[data-ay-sheet]");
    if (!burger || !sheet) return;
    function set(open) {
      sheet.dataset.open = String(open);
      burger.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
      if (open) { var f = sheet.querySelector("a, button"); if (f) f.focus(); }
    }
    on(burger, "click", function () { set(sheet.dataset.open !== "true"); });
    on(sheet.querySelector("[data-ay-sheet-close]"), "click", function () { set(false); burger.focus(); });
    all("a", sheet).forEach(function (a) { on(a, "click", function () { set(false); }); });
    on(document, "keydown", function (e) {
      if (e.key === "Escape" && sheet.dataset.open === "true") { set(false); burger.focus(); }
    });
  })();

  /* ---------- shop mega-menu --------------------------------
     Hover opens it, but hover is never the only way in: it also opens
     on keyboard focus, ArrowDown moves into the panel (and is the only
     way back in after Escape, since focus never leaves the trigger),
     and where there is no hover the first tap opens instead of
     navigating. The panel is [hidden] while closed so its links stay
     out of the tab order. */
  all("[data-ay-mega]").forEach(function (item) {
    var trigger = item.querySelector("[data-ay-mega-trigger]");
    var panel = item.querySelector("[data-ay-mega-panel]");
    if (!trigger || !panel) return;

    var TOUCH = window.matchMedia("(hover: none)").matches;
    var openT = null, closeT = null, tapped = false, primed = false;
    var isOpen = function () { return item.dataset.open === "true"; };

    var fig = panel.querySelector("[data-ay-mega-fig]");
    var img = panel.querySelector("[data-ay-mega-img]");
    var cap = panel.querySelector("[data-ay-mega-cap]");

    function prime() {
      if (primed) return;
      primed = true;
      /* decode every preview up front so the swap never flashes empty */
      all("[data-ay-mega-item]", panel).forEach(function (a) {
        if (a.dataset.img) { var i = new Image(); i.src = a.dataset.img; }
      });
    }

    all("[data-ay-mega-item]", panel).forEach(function (a) {
      function show() {
        if (!img || !a.dataset.img || img.getAttribute("src") === a.dataset.img) return;
        if (RM) { img.src = a.dataset.img; if (cap) cap.textContent = a.dataset.cap || ""; return; }
        if (fig) fig.dataset.swapping = "true";
        var next = new Image();
        next.onload = next.onerror = function () {
          img.src = a.dataset.img;
          if (cap) cap.textContent = a.dataset.cap || "";
          if (fig) fig.dataset.swapping = "false";
        };
        next.src = a.dataset.img;
      }
      on(a, "mouseenter", show);
      on(a, "focus", show);
    });

    function open() {
      clearTimeout(closeT);
      prime();
      panel.hidden = false;
      void panel.offsetWidth;
      item.dataset.open = "true";
      trigger.setAttribute("aria-expanded", "true");
    }
    function close(refocus) {
      clearTimeout(openT);
      item.dataset.open = "false";
      trigger.setAttribute("aria-expanded", "false");
      tapped = false;
      closeT = setTimeout(function () { panel.hidden = true; }, RM ? 0 : 220);
      if (refocus) trigger.focus();
    }

    if (!TOUCH) {
      on(item, "mouseenter", function () { clearTimeout(closeT); openT = setTimeout(open, 90); });
      on(item, "mouseleave", function () { clearTimeout(openT); closeT = setTimeout(function () { close(false); }, 200); });
    } else {
      on(trigger, "click", function (e) { if (!tapped) { e.preventDefault(); open(); tapped = true; } });
      on(document, "click", function (e) { if (isOpen() && !item.contains(e.target)) close(false); });
    }

    on(trigger, "focus", open);
    on(item, "focusout", function (e) { if (!item.contains(e.relatedTarget)) close(false); });
    on(trigger, "keydown", function (e) {
      if (e.key !== "ArrowDown") return;
      e.preventDefault();
      if (!isOpen()) open();
      var first = panel.querySelector("[data-ay-mega-item]");
      if (first) setTimeout(function () { first.focus(); }, 0);
    });
    on(document, "keydown", function (e) { if (e.key === "Escape" && isOpen()) { e.preventDefault(); close(true); } });
    /* the header is sticky and hides on scroll — don't leave the panel hanging */
    on(window, "scroll", function () { if (isOpen()) close(false); }, { passive: true });
  });

  /* ---------- PDP: size choice + add to cart ---------------- */
  (function () {
    var form = document.querySelector("[data-ay-pdp-form]");
    if (!form) return;
    var idInput = form.querySelector("[data-ay-variant-id]");
    var err = document.querySelector("[data-ay-size-err]");
    var atc = form.querySelector("[data-ay-atc]");
    var chosen = null;

    all("[data-ay-size]", form).forEach(function (b) {
      on(b, "click", function () {
        if (b.disabled) return;
        chosen = b.getAttribute("data-ay-size");
        all("[data-ay-size]", form).forEach(function (x) { x.setAttribute("aria-pressed", String(x === b)); });
        if (idInput) idInput.value = chosen;
        if (err) err.hidden = true;
      });
    });

    /* if only one variant is purchasable, pick it so the shopper can't
       hit a "choose a size" wall on a single-size product */
    var avail = all("[data-ay-size]", form).filter(function (b) { return !b.disabled; });
    if (avail.length === 1) avail[0].click();

    on(form, "submit", function (e) {
      if (!chosen) {
        e.preventDefault();
        if (err) err.hidden = false;
        var s = form.querySelector(".ay-sizes");
        if (s) s.scrollIntoView({ block: "center", behavior: RM ? "auto" : "smooth" });
        return;
      }
      if (atc) { atc.disabled = true; atc.dataset.busy = "true"; }
    });
  })();

  /* ---------- newsletter offer ------------------------------
     Once per visitor, on intent rather than arrival: whichever comes
     first of 40% scroll depth or a 15s dwell. Never while the mobile
     sheet or a dialog is already up.

     Two steps: a one-tap question, and only then the address. The
     answer is worth as much as the email — it becomes a customer tag,
     so the occasion collections can be segmented on later. */
  (function () {
    var pop = document.querySelector("[data-ay-pop]");
    if (!pop) return;

    var KEY = "aydo.nl.v1";
    var seen = null;
    try { seen = localStorage.getItem(KEY); } catch (e) {}
    if (seen) return;

    var panel = pop.querySelector(".ay-pop__panel");
    var body = pop.querySelector("[data-ay-pop-body]");
    var form = pop.querySelector("[data-ay-pop-form]");
    var input = pop.querySelector("[data-ay-pop-email]");
    var phone = pop.querySelector("[data-ay-pop-phone]");
    var errEl = pop.querySelector("[data-ay-pop-err]");
    var code = pop.getAttribute("data-ay-code") || "";
    var opener = null, armed = true;

    /* The panel is display:none until it opens, and a browser does not
       fetch images inside a display:none subtree — so the photograph only
       started downloading at the moment the pop-up appeared, and the first
       thing the visitor saw was an empty grey panel. Warm it in the
       background instead, well before anything is shown. */
    (function warmFigure() {
      var fig = pop.querySelector(".ay-pop__fig img");
      if (!fig) return;
      var src = fig.getAttribute("src");
      if (!src) return;
      var warm = function () { var i = new Image(); i.src = src; };
      if (window.requestIdleCallback) window.requestIdleCallback(warm, { timeout: 3000 });
      else setTimeout(warm, 1200);
    })();

    /* two steps: the question earns the email field */
    var step1 = pop.querySelector('[data-ay-pop-step="1"]');
    var step2 = pop.querySelector('[data-ay-pop-step="2"]');
    var answerEl = pop.querySelector("[data-ay-pop-answer]");
    var answerTxt = pop.querySelector("[data-ay-pop-answer-txt]");
    var answer = "";

    function step(n) {
      if (!step1 || !step2) return;
      step1.hidden = n !== 1;
      step2.hidden = n !== 2;
      var focusable = n === 1 ? step1.querySelector("button") : input;
      if (focusable) focusable.focus({ preventScroll: true });
    }

    all("[data-ay-pop-pick]", pop).forEach(function (b) {
      on(b, "click", function () {
        all("[data-ay-pop-pick]", pop).forEach(function (o) { o.setAttribute("aria-pressed", "false"); });
        b.setAttribute("aria-pressed", "true");
        answer = b.getAttribute("data-ay-pop-pick") || "";
        if (answerTxt) answerTxt.textContent = (b.querySelector("b") || b).textContent.trim();
        if (answerEl) answerEl.hidden = false;
        step(2);
      });
    });
    /* skipping is allowed — a required question is just a slower toll gate */
    on(pop.querySelector("[data-ay-pop-skip]"), "click", function () {
      answer = "";
      if (answerEl) answerEl.hidden = true;
      step(2);
    });
    on(pop.querySelector("[data-ay-pop-back]"), "click", function () { step(1); });

    /* "subscribed" outranks "dismissed" — closing the success card with
       the X must not downgrade the record of what the visitor did. */
    function remember(v) {
      try {
        if (v === "dismissed" && localStorage.getItem(KEY) === "subscribed") return;
        localStorage.setItem(KEY, v);
      } catch (e) {}
    }
    /* Never open on top of something the shopper already opened. This list
       has to name EVERY overlay, not just the ones that existed when it was
       written: the pop-up sits at z-index 61, above the filter panel at 55,
       so an unlisted overlay does not merely get covered — it stops
       receiving taps entirely, and looks broken rather than obscured. That
       is exactly what happened to the colour filter: Colour is the last
       group in the panel, so reaching it takes longer than the 15s dwell,
       and the pop-up landed on top mid-choice.

       Returning true here does NOT burn the offer — `armed` is only cleared
       once the pop-up actually opens, so it still appears later. */
    function blocked() {
      var sheet = document.querySelector("[data-ay-sheet]");
      if (sheet && sheet.dataset.open === "true") return true;
      var openish = [
        "[data-ay-filter-panel]",  /* collection filter panel */
        "[data-ay-cart]",          /* bag drawer */
        "[data-ay-srch]",          /* search dropdown */
        ".ay-lb"                   /* product-image lightbox */
      ];
      var busy = openish.some(function (sel) {
        return all(sel).some(function (el) { return !el.hidden; });
      });
      if (busy) return true;
      return all(".ay-dialog").some(function (d) { return !d.hidden; });
    }
    function open() {
      if (!armed || blocked()) return;
      armed = false;
      opener = document.activeElement;
      pop.hidden = false;
      void pop.offsetWidth;
      pop.dataset.open = "true";
      document.body.style.overflow = "hidden";
      /* land on the question, not the input — the first thing asked for
         should be the cheap thing */
      var lead = step1 ? step1.querySelector("button") : (input || panel);
      (lead || panel).focus({ preventScroll: true });
    }
    function close(reason) {
      pop.dataset.open = "false";
      document.body.style.overflow = "";
      remember(reason || "dismissed");
      setTimeout(function () { pop.hidden = true; }, RM ? 0 : 280);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    all("[data-ay-pop-close]", pop).forEach(function (b) { on(b, "click", function () { close("dismissed"); }); });
    on(document, "keydown", function (e) {
      if (pop.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close("dismissed"); return; }
      if (e.key !== "Tab") return;
      var f = all("button, [href], input", panel).filter(function (el) { return el.offsetParent !== null; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });

    on(form, "submit", function (e) {
      e.preventDefault();
      var v = (input.value || "").trim();
      if (!/^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/.test(v)) { if (errEl) errEl.hidden = false; input.focus(); return; }
      if (errEl) errEl.hidden = true;
      remember("subscribed");
      body.innerHTML =
        '<p class="ay-eyebrow">You’re on the list</p>' +
        '<h2 class="ay-display">I do, too.</h2>' +
        '<p>Ten percent off your first pair. The code is yours — it is also in your inbox.</p>' +
        '<strong class="ay-pop__code">' + code + '</strong>' +
        '<button class="ay-link ay-pop__no" type="button" data-ay-pop-close>Close</button>';
      var b = body.querySelector("[data-ay-pop-close]");
      on(b, "click", function () { close("subscribed"); });
      b.focus({ preventScroll: true });
      /* hand what we collected to Shopify's own customer list in the
         background. The answer rides along as a tag so the four occasion
         collections can be segmented on without a third-party tool. */
      var hidden = document.querySelector("[data-ay-pop-relay]");
      if (hidden) {
        var f2 = hidden.querySelector('input[name="contact[email]"]');
        var f3 = hidden.querySelector('input[name="contact[phone]"]');
        var tags = hidden.querySelector("[data-ay-pop-tags]");
        if (f3 && phone && phone.value.trim()) f3.value = phone.value.trim();
        else if (f3) f3.remove(); /* an empty phone would fail Shopify's validation */
        if (tags && answer) tags.value = tags.value + ",occasion-" + answer;
        if (f2) { f2.value = v; hidden.submit(); }
      }
    });

    var timer = setTimeout(open, 15000);
    function onScroll() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      if (h > 0 && window.scrollY / h > 0.4) { clearTimeout(timer); open(); }
      if (!armed) window.removeEventListener("scroll", onScroll);
    }
    on(window, "scroll", onScroll, { passive: true });
  })();

  /* ---------- reveal on scroll ------------------------------ */
  if (!RM && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es, ob) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.dataset.ayIn = "true"; ob.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    all("[data-ay-reveal]").forEach(function (el) { io.observe(el); });
  } else {
    all("[data-ay-reveal]").forEach(function (el) { el.dataset.ayIn = "true"; });
  }
})();